import { Controller } from "@hotwired/stimulus";
import * as bootstrap from "bootstrap";

export default class extends Controller {
  connect() {
    this.openFromUrl();
    this.handlePendingAction();
  }

  openModal(event) {
    const row = event.currentTarget;
    const modalId = row.dataset.modalId;
    if (!modalId) return;

    const modalEl = document.getElementById(modalId);
    if (!modalEl) return;

    const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
    modal.show();
  }

  openFromUrl() {
    const url = new URL(window.location.href);
    const modalRowId = url.searchParams.get("open_zabbix_host");
    const highlightRowId = url.searchParams.get("highlight_zabbix_host");

    if (modalRowId) {
      if (this.openModalByRowId(modalRowId)) {
        return;
      }

      url.searchParams.delete("open_zabbix_host");
      window.history.replaceState({}, "", url.toString());
      return;
    }

    if (highlightRowId) {
      if (this.highlightRowById(highlightRowId)) {
        return;
      }

      url.searchParams.delete("highlight_zabbix_host");
      window.history.replaceState({}, "", url.toString());
    }
  }

  openModalByRowId(rowId) {
    const row = document.getElementById(rowId);
    if (!row) return false;

    this.highlightRowById(rowId);

    const modalId = row.dataset.modalId;
    if (!modalId) return false;

    const modalEl = document.getElementById(modalId);
    if (!modalEl) return false;

    const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
    modal.show();

    return true;
  }

  highlightRowById(rowId) {
    document
      .querySelectorAll("tr.table-active")
      .forEach((row) => row.classList.remove("table-active"));

    const row = document.getElementById(rowId);
    if (!row) return false;

    row.classList.add("table-active");
    row.scrollIntoView({ block: "center", behavior: "smooth" });

    return true;
  }

  handlePendingAction() {
    let payload;
    try {
      payload = JSON.parse(sessionStorage.getItem("zabbixHostsPending"));
    } catch (_error) {
      payload = null;
    }

    if (!payload) return;

    const handled =
      (payload.modalRowId && this.openModalByRowId(payload.modalRowId)) ||
      (payload.highlightRowId &&
        this.highlightRowById(payload.highlightRowId));

    if (handled) {
      try {
        sessionStorage.removeItem("zabbixHostsPending");
      } catch (_error) {}
    }
  }
}
